export const FormatText = (text: string, count: number) => {
  if (text) {
    return text.slice(0, count) + (text.length > count ? '...' : '')
  }
  return ''
}
